module.exports = __webpack_public_path__ + "img/money-alt.34a9cae0.svg";